// extracted by mini-css-extract-plugin
export default {"card":"ProjectDetails_card__dOQk6","stats":"ProjectDetails_stats__vYyQx","h1":"ProjectDetails_h1__aSJud","row":"ProjectDetails_row__Iw+9n"};